/**
 * @generated SignedSource<<45eb54206aa80f8b681379fd99d07765>>
 * @relayHash e435d6d2ef1fb5eebfc9d5c505f1e65c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c4bdbbd0abf52ccb487e52e67e59bd8bdce38ce12908470cb465fcad9d07bfba

import type { ConcreteRequest } from 'relay-runtime';
export type ContentDataClassificationMutationContentStatus = "CURRENT" | "DRAFT" | "%future added value";
export type useContentClassificationBulkUpdateContentDataClassificationLevelMutation$variables = {
  classificationLevelId: string;
  contentStatuses: ReadonlyArray<ContentDataClassificationMutationContentStatus | null>;
  id: AGG$Long;
};
export type useContentClassificationBulkUpdateContentDataClassificationLevelMutation$data = {
  readonly bulkUpdateContentDataClassificationLevel: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null;
    }> | null;
    readonly success: boolean;
  } | null;
};
export type useContentClassificationBulkUpdateContentDataClassificationLevelMutation = {
  response: useContentClassificationBulkUpdateContentDataClassificationLevelMutation$data;
  variables: useContentClassificationBulkUpdateContentDataClassificationLevelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "classificationLevelId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatuses"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "classificationLevelId",
            "variableName": "classificationLevelId"
          },
          {
            "kind": "Variable",
            "name": "contentStatuses",
            "variableName": "contentStatuses"
          },
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "BulkUpdateContentDataClassificationLevelPayload",
    "kind": "LinkedField",
    "name": "bulkUpdateContentDataClassificationLevel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "e435d6d2ef1fb5eebfc9d5c505f1e65c",
    "id": "c4bdbbd0abf52ccb487e52e67e59bd8bdce38ce12908470cb465fcad9d07bfba",
    "metadata": {},
    "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
    "operationKind": "mutation",
    "text": "mutation useContentClassificationBulkUpdateContentDataClassificationLevelMutation($id:Long!,$contentStatuses:[ContentDataClassificationMutationContentStatus]!,$classificationLevelId:ID!){bulkUpdateContentDataClassificationLevel(input:{id:$id,contentStatuses:$contentStatuses,classificationLevelId:$classificationLevelId}){success,errors{message}}}"
  }
};
})();

(node as any).hash = "9839fe96ab36e63f6aab91bb7d0d00f7";

export default node;
